// extracted by mini-css-extract-plugin
export default {"content":"main-page_content__jSflQ","box":"main-page_box__gof+4","title":"main-page_title__0Limq"};